export default __webpack_public_path__ + "assets/models/5e4baec461471356cf7bc60747f2e5b5.glb";